import { useTranslation } from 'react-i18next';

import { SequenceImageType } from '../../../constants/sequenceImages';
import { SequenceImage } from '../../Molecules';
import { BasicPopupContainer } from '../Containers/BasicPopupContainer';

import styles from './CreateGameWordSelectInfoPopup.module.css';

type CreateGameWordSelectInfoPopupProps = {
  type: SequenceImageType;
  onPrimary: () => void;
};

export const CreateGameWordSelectInfoPopup = (
  props: CreateGameWordSelectInfoPopupProps,
) => {
  const { onPrimary, type } = props;
  const { t } = useTranslation();

  return (
    <BasicPopupContainer onPrimaryButtonClick={onPrimary}>
      <div className={styles.popupContent}>
        <div className={styles.description}>
          {t('Click the word to select or deselect')}
        </div>
        <div className={styles.image}>
          <SequenceImage type={type} />
        </div>
      </div>
    </BasicPopupContainer>
  );
};
